<template lang="pug">
main
  br
  .container
    article.message.is-info
      .message-header
        p Información de envio del Comprobante Electrónico
      .message-body(v-if="track[0]")
        p Comprobante:
          strong {{ ' ' + track[0].codigo + ' ' + track[0].numero }}
        p(v-if="track[0].numeroAutorizacion") Autorización: {{ track[0].numeroAutorizacion }}
        //- p(v-if="track[0].fechaAutorizacion") Fecha Autorización: {{ track[0].fechaAutorizacion }}
        p Estado:
          strong {{ ' ' + track[0].estado }}
        p
          strong Observación:
        p {{ track[0].observacion }}
  br
</template>
<script>
import trackService from '@/services/track'

export default {
  data: () => ({
    track: []
  }),

  created () {
    const numero = this.$route.params.numero
    trackService.electronicoById(numero)
      .then(res => {
        this.track = res
      })
  }
}
</script>
<style lang="scss" scoped>
</style>
